import { stringFromJSONValue } from '../../models/parser'

type TimeDisplayOption = 'LOCAL' | 'AGENCY' | 'BOTH'

export const timeDisplayOptions: TimeDisplayOption[] = ['LOCAL', 'AGENCY', 'BOTH']

export const timeDisplayOptionDescription = (option: TimeDisplayOption) => {
  switch (option) {
    case 'LOCAL':
      return 'Local time'
    case 'AGENCY':
      return 'Agency time'
    case 'BOTH':
      return 'Local and Agency Time'
  }
}

export const timeDisplayOptionFromValue = (value: any): TimeDisplayOption => {
  const str = stringFromJSONValue(value)
  switch (str) {
    case 'LOCAL':
      return 'LOCAL'
    case 'AGENCY':
      return 'AGENCY'
    case 'BOTH':
      return 'BOTH'
  }
  return 'LOCAL'
}

export default TimeDisplayOption
